import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home"
import Background from "../views/Background"
import Publications from "../views/Publications"

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: "Jiaming Qiu's webpage"
        }
    },
    {
        path: '/background',
        name: 'Background',
        component: Background,
        meta: {
            title: "Background"
        }
    },
    {
        path: '/publications',
        name: 'Publications',
        component: Publications,
        meta: {
            title: "Publications"
        }
    }
]

const router = new VueRouter({
    routes
})

const DEFAULT_TITLE = "Jiaming Qiu's webpage";
router.afterEach((to,) => {
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
});

export default router